import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=402035db&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=ts"
export * from "./Channel.vue?vue&type=script&lang=ts"
import style0 from "./Channel.vue?vue&type=style&index=0&id=402035db&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402035db",
  null
  
)

export default component.exports